// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1jyop","signatureBlock":"Footer_signatureBlock__1Ve0C","signature":"Footer_signature__3fik0"};